import { openMailto } from "@/utils/mailto";
import Hero from "../components/hero";
import { AboutUsPage } from "@features/general";
import heroImage from "@assets/images/about-hero.svg";
import emergencyIcon from "@assets/icons/emergencyIcon.svg";

const heroData = {
  title: "Powering Safety. Delivering Trust.",
  description:
    "Gaz Investment in Oil and Gas Supply L.L.C. (GAZ) is a UAE licensed engineering and utility management company providing complete LPG / SNG gas supply, metering, billing, and maintenance solutions. We combine local expertise, certified safety standards, and cutting-edge technology to deliver reliable, transparent, and sustainable energy for residential, commercial, and industrial clients.",
  image: heroImage,
  buttonText: "View Our Brochure",
  buttonOnclick: () =>
    openMailto({
      subject: "Request: Company Brochure",
      body: "Hello,\n\nI would like to request a copy of the GAZ company brochure.\n\nThank you.",
    }),
  footerText:
    "Our licensed technicians and 24/7 emergency response team are always ready to protect your home and business.",
  footerButtonText: "Report an Emergency Online",
  footerButtonOnclick: () =>
    openMailto({
      subject: "Emergency Report",
      body: "Emergency Type:\nLocation:\nDescription:\n",
    }),
  footerIcon: <img src={emergencyIcon} alt="" className="w-7 h-7" />,
};

function AboutUs() {
  return <AboutUsPage hero={<Hero data={heroData} />} />;
}

export default AboutUs;
